export const PHONE_NUMBER_TO_READ = `726 280 872`;
export const PHONE_NUMBER = PHONE_NUMBER_TO_READ.split(` `).join(``);
export const EMAIL_ADDRESS = `info@daimley.pl`;
export const OPINION_EMAIL_ADDRESS = `opinie@daimley.pl`;
